var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('d-header',{attrs:{"fluid":"","actions":[{
      label: _vm.$t('save'),
      primary: true,
      color: 'is-primary',
      action: _vm.submitForm
    }],"breadcrumbs":false}},[_c('h1',{staticClass:"title"},[_c('d-previous-btn',{attrs:{"path":'/properties/' + _vm.$route.params.property + '/property-inspections'}}),_vm._v("\n      "+_vm._s(_vm.$t('new_property_inspection'))+"\n    ")],1)]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"create","property-id":_vm.model.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }